import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const CopyIcon = ({
  width = "24",
  height = "24",
  color = "white",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3158 19.3636H9.05263V7.90909H18.3158M18.3158 6.27273H9.05263C8.60595 6.27273 8.17757 6.44513 7.86171 6.75201C7.54586 7.05888 7.36842 7.4751 7.36842 7.90909V19.3636C7.36842 19.7976 7.54586 20.2138 7.86171 20.5207C8.17757 20.8276 8.60595 21 9.05263 21H18.3158C18.7625 21 19.1909 20.8276 19.5067 20.5207C19.8226 20.2138 20 19.7976 20 19.3636V7.90909C20 7.4751 19.8226 7.05888 19.5067 6.75201C19.1909 6.44513 18.7625 6.27273 18.3158 6.27273ZM15.7895 3H5.68421C5.23753 3 4.80914 3.1724 4.49329 3.47928C4.17744 3.78616 4 4.20237 4 4.63636V16.0909H5.68421V4.63636H15.7895V3Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
